module.exports = __webpack_public_path__ + "static/c7-6550945dd47e2eeea61827d3dafd523f.jpeg";